export default __webpack_public_path__ + "static/media/icons8-nginx.7a2b6959.svg";